export const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

interface SkipAnimationsConfig {
  skipAnimations: boolean;
}

// The slice of MediaQueryList this needs; a real `matchMedia()` result fits.
interface ReducedMotionMediaQuery {
  readonly matches: boolean;
  addEventListener(
    type: 'change',
    listener: (event: { readonly matches: boolean }) => void
  ): void;
}

/**
 * Make framer-motion jump every animation to its end state while the user
 * asks the OS for reduced motion, and follow the preference if it changes.
 *
 * framer-motion's own `MotionConfig reducedMotion="user"` only drops
 * transform/layout animations — opacity fades still play. Those fades are
 * JS-driven (inline styles per frame), so a CSS `transition: none` cannot
 * reach them either: the a11y gate's axe `color-contrast` rule sampled
 * WelcomeScreen and the suggestion chips half-faded and failed nightly
 * E2E run 37249466784 (2026-10-05). `skipAnimations` settles them at once.
 */
export function syncSkipAnimationsWithReducedMotion(
  config: SkipAnimationsConfig,
  mediaQuery: ReducedMotionMediaQuery
): void {
  config.skipAnimations = mediaQuery.matches;
  mediaQuery.addEventListener('change', (event) => {
    config.skipAnimations = event.matches;
  });
}
